import { render, staticRenderFns } from "./NavigationMobile.vue?vue&type=template&id=82a90cd8&scoped=true&"
import script from "./NavigationMobile.vue?vue&type=script&lang=js&"
export * from "./NavigationMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMobile.vue?vue&type=style&index=0&id=82a90cd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a90cd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
